export const styles = {
	nextBtn: {
		display: 'flex',
		justifyContent: 'flex-end',
		marginRight: '-24px',
		marginBottom: '16px',
		marginTop: '8px',
		marginLeft: '8px',
		flexGrow: 1
	},
	successWrapper: {
		marginLeft: '35px',
		'@media(max-width: 500px)': {
			marginLeft: '15px'
		},
		'& span': {
			marginRight: '15px',
			whiteSpace: 'nowrap'
		},
		'& p': {
			marginTop: '10px'
		},
		'& .MuiInputBase-root': {
			border: '1px solid #cccccc',
			borderRadius: '4px',
			boxShadow: 'inset 0 1px 1px rgb(0 0 0 / 8%)',
			color: '#555555',
			height: '34px',
			padding: '10px',
			width: '100%',
			maxWidth: '400px'
		},
		'& .MuiInput-underline:before, & .Mui-focused.MuiInput-underline:after': {
			display: 'none'
		}
	},
	successContent: {
		display: 'flex',
		alignItems: 'center',
		'@media(max-width: 500px)': {
			flexDirection: 'column',
			alignItems: 'flex-start'
		}
	},
	actions: {
		width: '100%',
		padding: '0 8px',
		marginTop: '8px'
	},
	arrows: {
		padding: '0 24px'
	}
};
